import React, { useEffect, useState } from "react";
import Page from "../Page.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import FormPartial from "./FormPartial.js";
import CsDiagnostics from "../../models/CsDiagnostics.js";
import { toast } from "react-toastify";
import ShowInfo from "./ShowInfo.js";
import { externalUrl } from "../../data/externalUrls.js";
import Loading from "../../components/Loading.js";
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import ShowSummaryData from "./ShowSummaryData.js";

const IndexForm = () => {
  const [csDiagnostics, setCsDiagnostics] = useState(new CsDiagnostics().toStateJson());
  let csDiagnosticsObj = new CsDiagnostics();
  const [csInformation, setCsInformation] = useState({});
  const [csLogCustomers, setCsLogCustomers] = useState([]);
  const [csLogData, setCsLogData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isApiCalled, setIsApiCalled] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    if(csDiagnostics.start_date !== csDiagnosticsObj.start_date || csDiagnostics.end_date !== csDiagnosticsObj.end_date){
      setCsInformation({});
      setCsLogCustomers([]);
      setCsLogData([]);
    }
  }, [csDiagnosticsObj.start_date, csDiagnosticsObj.end_date, csDiagnostics.start_date, csDiagnostics.end_date])

  const fetchData = async (params) => {
    try {
      setIsLoading(true);
      const formData = new URLSearchParams();
      formData.append('device_id', params.cs_diagonostics.device_id);
      formData.append('start_time', params.cs_diagonostics.start_date);
      formData.append('end_time', params.cs_diagonostics.end_date);

      // CS Information
      await axios.post(`${externalUrl.flaskServiceUrl}/CS_Diagnostics/cs_information`, formData)
      .then((response) => {
        if (response?.data?.data && response?.data?.data.length > 0) {
          setCsInformation(response?.data?.data[0]);
        } else {
          toast.warning("CS information data not found or empty.")
        }
      })
      .catch(error => {
        toast.error(error?.message);
      });
      // CS Log For Customer
      await axios.post(`${externalUrl.flaskServiceUrl}/CS_Diagnostics/cs_log_customer`, formData)
      .then((response) => {
        if(response.data?.data?.length === 0 || response.data?.data === null){
          toast.warning("Customer wise data not found or empty.")
        } else {
          setCsLogCustomers(response?.data?.data);
        }
      })
      .catch(error => {
        toast.error(error?.message);
      });
      // Upload logs (CHARGING STATION LOG FILE)
      await axios.post(`${externalUrl.flaskServiceUrl}/CS_Diagnostics/upload_log`, formData)
      .then((response) => {
        if(response.data?.data?.length === 0 || response.data?.data === null){
          toast.warning("CS log file data not found or empty.")
        } else {
          setCsLogData(response?.data?.data);
          toast.success("Data Fetched Successfully");
        }
      })
      .catch(error => {
        toast.error(error?.message);
      });

    } catch(error) {
      csDiagnosticsObj.set_api_errors(error?.data?.data?.errors);
      toast.error(error?.data?.message || 'Something went wrong !');
    } finally {
      setIsLoading(false);
    }
  }

  const onSearchClick = () => {
    try{
      setIsApiCalled(true);
      setCsInformation({});
      setCsLogCustomers([]);
      setCsLogData([]);
      fetchData((new CsDiagnostics(csDiagnostics)).toApiJson());
    } catch(error){
      setCsDiagnostics(new CsDiagnostics(csDiagnostics));
    }
  }

  const onMqttButtonClick = () => {
    try{
      setCsInformation({});
      setCsLogCustomers([]);
      setCsLogData([]);
      handleShowModal();
    } catch(error){
      setCsDiagnostics(new CsDiagnostics(csDiagnostics));
    }
  }

  const onMqttOkClick = async (params) => {
    try{
      setIsLoading(true);
      setCsInformation({});
      setCsLogCustomers([]);
      setCsLogData([]);

      const formData = new URLSearchParams();
      formData.append('device_id', params.cs_diagonostics.device_id);
      formData.append('start_time', params.cs_diagonostics.start_date);

      await axios.post(`${externalUrl.flaskServiceUrl}/CS_Diagnostics/MQTT_Button`, formData)
      .then((response) => {
      })
      .catch(error => {
        toast.error(error?.message || 'Something went wrong!');
      });
      fetchData((new CsDiagnostics(csDiagnostics)).toApiJson());
    }
    catch(error){
      setCsDiagnostics(new CsDiagnostics(csDiagnostics));
    }
    finally {
      setIsLoading(false);
      setIsApiCalled(false);
      handleCloseModal();
      // fetchData((new CsDiagnostics(csDiagnostics)).toApiJson());
    }
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.ChargingStationDiagnosticsPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Charging Station Diagnostics" }]}
    className={'charging-station-diagnostics-page'}
  >
    <PageContentWrapper contentHeading={"Charging Station Diagnostics"}>
      {isLoading && <Loading />}
      <div className="row m-2 mt-4">
        <form autoComplete="off">
          <span className="row row-cols-auto">
            <span className="col-8">
              <FormPartial csDiagnostics={csDiagnostics} setCsDiagnostics={setCsDiagnostics} setIsLoading={setIsLoading}/>
            </span>
            <span className="col">
              <button
                style={{ height: '30px' }}
                type="button"
                className="btn btn-voltup-theme mt-3"
                onClick={onSearchClick}
                disabled={csDiagnostics.charging_station.length === 0 || csDiagnostics.start_date === "" || csDiagnostics.end_date === ""}
              >
                Search
              </button>
            </span>
            <span className="col">
              <button
                style={{ height: '30px' }}
                type="button"
                className="btn btn-voltup-theme mt-3"
                onClick={onMqttButtonClick}
                disabled={csDiagnostics.charging_station.length === 0 || csDiagnostics.start_date === "" || csDiagnostics.end_date === "" || !(isApiCalled && csLogData.length === 0)}
              >
                MQTT
              </button>
            </span>
          </span>
        </form>
      </div>
      <div className="row m-1 mt-2">
        <ShowInfo csInformation={csInformation} csLogCustomers={csLogCustomers} csLogData={csLogData} />
      </div>
      <div className="row m-1 mt-2">
        <ShowSummaryData csDiagnostics={csDiagnostics} setIsLoading={setIsLoading}/>
      </div>
      <div className="container">
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          backdrop="static"
          keyboard={false}
          scrollable={true}
          centered
        >
          <Modal.Header
            style={{ backgroundImage: 'linear-gradient(103deg, #49c12b 0, #197800 99%)' }}
            className="text-white"
            closeButton
          >
            <Modal.Title>Fetch Data From Charging Station</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className='h6 text-center my-3 opacity-75 fw-normal'>
              Fetching data may take up to <span className="fw-bold"> 30 seconds</span>.
            </p>
            <p className="h4 text-center my-3 opacity-75">Do you want to proceed?</p>
            <p className="text-center mt-3 opacity-75" style={{ fontSize: '90px' }}><FontAwesomeIcon icon={faExclamationCircle} className="text-warning"/></p>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-sm rounded-5 btn-outline-secondary"
              style={{ width: "80px", fontSize: '16px' }}
              onClick={handleCloseModal}
            >
              Cancel
            </button>
            <button
              type='submit'
              className='btn btn-sm add-button'
              style={{ width: "80px", fontSize: '16px' }}
              onClick={(e) => {e.preventDefault(); onMqttOkClick((new CsDiagnostics(csDiagnostics)).toApiJson())}}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </PageContentWrapper>
  </Page>
};

export default IndexForm;
